import { useState, useEffect } from 'react';

const TERMS_ACCEPTED_KEY = 'tempvault_terms_accepted';
const COOKIE_CONSENT_KEY = 'tempvault_cookie_consent';

export const useTermsAccepted = () => {
  const [termsAccepted, setTermsAccepted] = useState(false);

  useEffect(() => {
    const checkTerms = () => {
      const hasAccepted = localStorage.getItem(TERMS_ACCEPTED_KEY) === 'true';
      setTermsAccepted(hasAccepted);
    };

    checkTerms();

    // Listen for storage changes (in case terms are accepted)
    const handleStorage = () => checkTerms();
    window.addEventListener('storage', handleStorage);

    // Also check periodically for same-tab updates
    const interval = setInterval(checkTerms, 500);

    return () => {
      window.removeEventListener('storage', handleStorage);
      clearInterval(interval);
    };
  }, []);

  return termsAccepted;
};

// Hook to check if user has given cookie consent for ads
export const useCookieConsent = () => {
  const [consent, setConsent] = useState<'pending' | 'accepted' | 'rejected'>('pending');

  useEffect(() => {
    const checkConsent = () => {
      const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (stored === 'accepted' || stored === 'rejected') {
        setConsent(stored);
      }
    };

    checkConsent();
    const interval = setInterval(checkConsent, 500);
    return () => clearInterval(interval);
  }, []);

  return consent;
};
